import React from 'react';
import { FiChevronLeft } from 'react-icons/fi';
import { DashboardSidebar } from '@/layouts/dashboard';
import { Link } from 'react-router-dom';

export default function EssaySidebar(props) {
  const { steps, currentStep, setCurrentStep, edit } = props;

  return (
    <DashboardSidebar
      hasBrand={false}
      viewMode="create"
    >
      <nav className="notebook-sidebar__nav">
        <Link
          to="/redacao"
          className="filter-bar__back"
        >
          <div className="card__icon-wrapper">
            <FiChevronLeft />
          </div>
          <span className="filter-bar__back-container">
            <span className="filter-bar__title">Redações</span>
          </span>
        </Link>

        <ul className="step-by-step-nav">
          {steps.map((step, index) => {
            return (
              <li
                className={`step-by-step-nav__item ${index === currentStep ? 'active' : ''} ${currentStep > index ? 'step-by-step-nav__item--completed' : ''}`}
                onClick={() => edit && setCurrentStep(index)}
                key={index}
              >
                <Link
                  to={edit ? `/redacao/criar/${step.route}` : ''}
                  className="step-by-step-nav__link"
                  style={{ cursor: edit ? 'pointer' : 'default' }}
                >
                  {step.text}
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
    </DashboardSidebar>
  );
}
